import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "./recommendedSection.css";
import { useTranslation } from "react-i18next";
import { fetchData } from "../../Api/dataApi";

const RecommendedProducts = () => {
  const { t } = useTranslation();
  const [displayedCategories, setDisplayedCategories] = useState([]);

  const fetchRecommendedProducts = useCallback(async () => {
    try {
      const categories = await fetchData();
      setDisplayedCategories(getRandomCategories(categories, 3));
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, []);

  const getRandomCategories = (data, count) => {
    const shuffled = [...data].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
  };

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    fetchRecommendedProducts();
  }, [fetchRecommendedProducts]);

  return (
    <div className="recommended-products">
      <h2>{t("recommended_products")}</h2>
      <div className="section-header">
        <Link to="/recommendedProducts" className="see-more">
          {t("see_more")} {">"}
        </Link>
      </div>
      <div className="product-grid">
        {displayedCategories.length > 0 ? (
          displayedCategories.map((category) => (
            <div className="product-card" key={category._id || category.id}>
              <Link to={`/product/${category._id || category.id}`}>
                <img
                  src={
                    Array.isArray(category.images) && category.images.length > 0
                      ? category.images[0]
                      : "default-image-url.jpg"
                  }
                  alt={category.title || t("no_name")}
                  className="product-image"
                />
                <div className="product-recommend-details">
                  {truncateText(category.title || t("No Name"), 3)}
                  <p>
                    {truncateText(
                      category.description || t("no_description"),
                      6
                    )}
                  </p>
                  <p>
                    {t("price")}: {category.price || t("no_price")}
                  </p>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <p>{t("loading_categories")}</p>
        )}
      </div>
    </div>
  );
};

export default RecommendedProducts;
